export const SKILL_MATRIX_SECTIONS = [
    { slug: "operazioni-standard", title: "Operazioni standard" },
    { slug: "abilitazioni", title: "Abilitazioni" },
    { slug: "requisiti-sicurezza", title: "Requisiti sicurezza" },
    { slug: "operatori-abilitati", title: "Operatori abilitati" },
    { slug: "controlli-manutenzioni", title: "Controlli e manutenzioni" },
    { slug: "storico-centri", title: "Storico centri" },
];

export function skillMatrixRoute(index, query = {}) {
    return { name: `hr-matrix-${SKILL_MATRIX_SECTIONS[index].slug}`, query };
}
